import { render, staticRenderFns } from "./FundsPage.vue?vue&type=template&id=a0c8bc94&"
import script from "./FundsPage.vue?vue&type=script&lang=js&"
export * from "./FundsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports